module.exports = __webpack_public_path__ + "assets/b3c502c7043d751d7e8b6d8738616516.svg";